import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sofía, Buenos Aires',
    text: 'Después de esta guía dejé de perseguir y ahora él me escribe primero todos los días. No lo puedo creer.',
    img: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&q=80&w=200'
  }, {
    name: 'Camila, Córdoba',
    text: 'Por primera vez me siento calmada y poderosa. Ya no sobrepienso cada cosa que dice.',
    img: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&q=80&w=200'
  }, {
    name: 'Martina, Rosario',
    text: 'El cambio es brutal. Me siento deseada, respetada y en control total.',
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80&w=200'
  }];
  return <section className="py-14 bg-white" data-id="element-210">
      <div className="max-w-6xl mx-auto px-6" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-212">
          <h2 className="text-3xl sm:text-4xl font-playfair text-deep-black mb-4" data-id="element-213">
            Lo que dicen las{' '}
            <span className="italic text-bordeaux" data-id="element-214">mujeres</span>
          </h2>
          <div className="w-16 h-0.5 bg-bordeaux mx-auto" data-id="element-215"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-216">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="bg-[#FAFAFA] p-8 border border-gray-100 flex flex-col items-center text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-217">
              <div className="w-20 h-20 rounded-full overflow-hidden mb-6 border-2 border-white shadow-md" data-id="element-218">
                <img src={t.img} alt={t.name} className="w-full h-full object-cover" data-id="element-219" />
              </div>
              <div className="flex space-x-1 mb-4" data-id="element-220">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-221" />)}
              </div>
              <p className="font-inter text-gray-700 italic mb-6 flex-grow" data-id="element-222">
                "{t.text}"
              </p>
              <p className="font-inter font-bold text-sm tracking-wide text-deep-black uppercase" data-id="element-223">
                — {t.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}